export const MAIL_UNSUBSCRIBE_PH_KEY = "UnregisterLink" as const;

export const MAIL_UNSUBSCRIBE_HREF_TOKEN = `{{.${MAIL_UNSUBSCRIBE_PH_KEY}}}`;

export const MAIL_UNSUBSCRIBE_CTA_LABEL = "Se désinscrire";

export type MailUnsubscribeBlock = {
  id: string;
  type: "unsubscribe";
};

export function createEmptyMailUnsubscribeBlock(blockId: string): MailUnsubscribeBlock {
  return { id: blockId, type: "unsubscribe" };
}

export function serializeMailUnsubscribeBlock(): string {
  const href = MAIL_UNSUBSCRIBE_HREF_TOKEN;
  const label = MAIL_UNSUBSCRIBE_CTA_LABEL;

  return `<table role="presentation" data-mail-unsubscribe="1" cellpadding="0" cellspacing="0" align="center" style="border-collapse:collapse;margin:16px auto;"><tr><td align="center" style="padding:0;font-family:Verdana,Geneva,sans-serif;font-size:12px;color:#6b7280;"><a href="${href}" style="color:#6b7280;text-decoration:underline;" target="_blank" rel="noopener noreferrer">${label}</a></td></tr></table>`;
}

export function parseMailUnsubscribeTable(
  el: HTMLElement,
  blockId: string,
): MailUnsubscribeBlock | null {
  if (el.getAttribute("data-mail-unsubscribe") !== "1") {
    return null;
  }

  return { id: blockId, type: "unsubscribe" };
}
